import { createContext } from 'react'

const BarcodeScannerContext = createContext({
    loaded: false,
    pScanner: undefined,
    useDynamicSoft: false,
})

export default BarcodeScannerContext
